import { $model, sendNotification, useApiClient } from '@msdk/common'
import { useCallback, useEffect } from 'react'
import { useRecoilRefresher_UNSTABLE } from 'recoil'

/**
 * Hook that listens for the ALT + R key combination to trigger a metadata refresh.
 * This functionality is enabled only in the local environment; when `production` is true, event listeners are not added.
 */

export function useResetMetadataCombination() {
  const apiClient = useApiClient()
  const invalidateCmps = useRecoilRefresher_UNSTABLE($model('CMPS'))

  const handleKeyPress = useCallback((event: KeyboardEvent) => {
    if (event.altKey && event.key === 'r') {
      sendNotification({ message: 'Reset Metadata Started!', status: 'info' })
      apiClient.metadata
        .resetMetadata()
        .then(() => {
          invalidateCmps()
          sendNotification({ message: 'Reset Metadata Completed!', status: 'success' })
        })
        .catch(() => {
          sendNotification({ message: 'Something went wrong!', status: 'error' })
        })
    }
  }, [])

  useEffect(() => {
    if (process.env.NODE_ENV == 'development') {
      document.addEventListener('keydown', handleKeyPress)
    }

    return () => {
      if (process.env.NODE_ENV == 'development') {
        document.removeEventListener('keydown', handleKeyPress)
      }
    }
  }, [handleKeyPress])
}
